import { gql } from '@apollo/client';
import { CYCLE_COUNT_FIELDS, CYCLE_COUNT_TEMPLATE_FIELDS } from './fragments';

// The list refetches after creation, so we only need the new row's id back to
// confirm the insert succeeded.
export const INSERT_CYCLE_COUNT = gql`
    ${CYCLE_COUNT_FIELDS}
    mutation InsertCycleCount($object: cycle_counts_insert_input!) {
        insert_cycle_counts_one(object: $object) {
            ...CycleCountFields
        }
    }
`;

export const INSERT_CYCLE_COUNT_TEMPLATE = gql`
    ${CYCLE_COUNT_TEMPLATE_FIELDS}
    mutation InsertCycleCountTemplate($object: cycle_count_templates_insert_input!) {
        insert_cycle_count_templates_one(object: $object) {
            ...CycleCountTemplateFields
        }
    }
`;

export const UPDATE_CYCLE_COUNT_TEMPLATE = gql`
    ${CYCLE_COUNT_TEMPLATE_FIELDS}
    mutation UpdateCycleCountTemplate(
        $cycle_count_template_id: uuid!
        $_set: cycle_count_templates_set_input!
    ) {
        update_cycle_count_templates_by_pk(
            pk_columns: { cycle_count_template_id: $cycle_count_template_id }
            _set: $_set
        ) {
            ...CycleCountTemplateFields
        }
    }
`;
